@keyframes blog-posts-spin {
  to { transform: rotate(360deg); }
}

.pagination {
  .previous_page, .next_page {
    @apply flex items-center flex-grow text-neutral-800;

    span {
      @apply flex flex-row gap-2 items-center;
    }

    &.disabled {
      @apply hidden sm:block sm:opacity-0;
    }
  }

  .previous_page {
    @apply justify-start;
  }

  .next_page {
    @apply justify-end;
  }

  .current, a, .gap {
    @apply flex items-center justify-center min-w-8 h-8 rounded text-neutral-800;
  }

  .current {
    @apply not-italic bg-neutral-900 text-neutral-0;
  }
}
